"use client";

import { useEffect, useState } from 'react';
import { canUseDOM } from 'utils/can-use-dom';

const QUERY = '(prefers-reduced-motion: no-preference)';

const getInitialState = () => {
  // eslint-disable-next-line react-hooks-ssr/react-hooks-global-ssr
  return canUseDOM() ? !window.matchMedia(QUERY).matches : true;
};

export function useReducedMotion() {
  const [prefersReducedMotion, setPrefersReducedMotion] = useState(
    getInitialState
  );

  useEffect(() => {
    const mediaQueryList = window.matchMedia(QUERY);

    const listener = (e: MediaQueryListEvent) => {
      setPrefersReducedMotion(!e.matches);
    };

    mediaQueryList.addListener(listener);

    return () => {
      mediaQueryList.removeListener(listener);
    };
  }, []);

  return prefersReducedMotion;
}
